import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { FiArrowLeft } from 'react-icons/fi';
import timeTrackingService from '../../services/timeTrackingService';
import projectService from '../../services/projectService';
import taskService from '../../services/taskService';
import TimeEntryForm from '../../components/TimeTracking/TimeEntryForm';

const TimeEntryCreate = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // Fetch projects
  const { data: projectsData } = useQuery({
    queryKey: ['projects'],
    queryFn: async () => {
      const response = await projectService.getAllProjects({ limit: 1000 });
      return response;
    },
  });

  // Fetch tasks
  const { data: tasksData } = useQuery({
    queryKey: ['tasks'],
    queryFn: async () => {
      const response = await taskService.getAllTasks({ limit: 1000 });
      return response;
    },
  });

  // Create mutation
  const createMutation = useMutation({
    mutationFn: timeTrackingService.createTimeEntry,
    onSuccess: () => {
      queryClient.invalidateQueries(['timeEntries']);
      toast.success('Time entry created successfully');
      navigate('/app/time-tracking');
    },
    onError: (error) => {
      toast.error(error.response?.data?.error || 'Failed to create time entry');
    },
  });

  const handleSubmit = async (data) => {
    await createMutation.mutateAsync(data);
  };

  const handleCancel = () => {
    navigate('/app/time-tracking');
  };

  return (
    <div className="max-w-4xl mx-auto">
      {/* Header */}
      <div className="mb-6">
        <button
          onClick={() => navigate('/app/time-tracking')}
          className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
        >
          <FiArrowLeft className="mr-2" />
          Back to Time Tracking
        </button>
        <h1 className="text-3xl font-bold text-gray-900">Create Time Entry</h1>
        <p className="mt-1 text-sm text-gray-600">
          Add a manual time entry for your work
        </p>
      </div>

      {/* Form */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <TimeEntryForm
          projects={projectsData?.projects || []}
          tasks={tasksData?.tasks || []}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      </div>
    </div>
  );
};

export default TimeEntryCreate;

